<template>
  <div>
    <!-- 头部logo与导航 -->
    <div class="header"
      style="background: #fff; width: 100%; height: 17.5rem; display: flex; justify-content: center; align-items: center;">
      <div style="display: flex; justify-content: space-between; align-items: center; width: 85%;">
        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
          <div style="display: flex; align-items: center;">
            <img :src="headerData.logo" alt="Logo" style="width: 10.85rem; height: 10.85rem;" />
            <span class="logoTitle">益巨科技</span>
          </div>
          <img :src="headerData.contentImg" alt="Logo" style="width: 30.85rem; height: 8rem;" @click="openPopup" />
        </div>
        <div style="display: flex; flex-direction: row;">
          <span v-for="(item, index) in headerData.title" :key="index" style="margin-left: 1.25rem; font-size: 3.5rem;"
            @click="goToPage(item.url)">
            {{ item.name }}
          </span>
        </div>
      </div>
    </div>

    <!-- 公司介绍 - 使用 vue-awesome-swiper 轮播图 -->
    <div v-if="Company_Profile.bgImgs && Company_Profile.bgImgs.length > 0" class="company-carousel">
      <swiper ref="companySwiper" :options="swiperOptions" @mouseenter="pauseAutoPlay" @mouseleave="startAutoPlay">
        <swiper-slide v-for="(bgImg, idx) in Company_Profile.bgImgs" :key="idx" class="swiper-slide-custom"
          :style="{ backgroundImage: 'url(' + bgImg + ')' }">
          <!-- 标题 -->
          <div style="display: flex; flex-direction: column; padding-top: 5rem;">
            <span style="font-size: 2.25rem; font-weight: 400; color: #fff;">{{ Company_Profile.title1 }}</span>
            <span style="font-size: 4.375rem; font-weight: 700; color: #fff; padding-top: 1.25rem;">{{
              Company_Profile.title2 }}</span>
          </div>

          <!-- 描述部分 -->
          <div v-if="filteredData1.length > 0"
            style="padding-top: 2.5rem; display: flex; flex-wrap: wrap; justify-content: center; align-items: center;">
            <div v-for="(item, index) in filteredData1" :key="index"
              style="display: flex; align-items: center; min-width: 15.625rem; flex-grow: 1;">
              <img :src="item.img" alt="Icon" style="width: 2.1875rem; height: 2.1875rem;" />
              <span
                style="font-size: 1.25rem; font-weight: 400; color: #fff; padding-left: 1.6rem; white-space: nowrap;">{{
                  item.content }}</span>
            </div>
          </div>

          <!-- 选项 -->
          <div v-if="filteredData2.length > 0"
            style="padding-top: 9.6875rem; display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center;">
            <div v-for="(item, index) in filteredData2" :key="index"
              style="width: 18.3125rem; height: 6.25rem; border-radius: 0.450625rem; border: 0.048125rem solid #fff; background: #FFFFFFCC; display: flex; justify-content: center; align-items: center;"
              @click="goTouristCardProject(item)">
              <div style="display: flex; align-items: center;">
                <span style="color: #303030; font-size: 1.6875rem; font-weight: 700;">{{ item.name }}</span>
                <img :src="item.img" style="width: 4.375rem; height: 4.375rem;" />
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>

      <!-- 分页器（必须放在 swiper 外部） -->
      <div class="swiper-pagination"></div>
    </div>

    <!-- 项目介绍 -->
    <div style="width: 100%; height: 25rem; background: #d9e7ff;" v-if="ProjectData.length > 0">
      <div class="container"
        style="display: flex; justify-content: center; align-items: center; height: 25rem; width: 100%;">
        <div class="container" style="width: 100%;">
          <div style="display: flex; justify-content: center; align-items: center;">
            <div v-for="(item, index) in ProjectData" :key="index"
              :class="['option', { 'option-hover': hoverIndex === index }]" @mouseover="hoverIndex = index"
              @mouseout="hoverIndex = null"
              style="display: flex; justify-content: center; align-items: center; width: 21.0625rem; height: 8.75rem; border-radius: 0.9375rem; margin-left: 1.25rem;">
              <div v-if="hoverIndex !== index" style="display: flex; align-items: center;">
                <span style="font-size: 2.35rem; font-weight: 500; color: #0078FF;">0{{ index + 1 }}</span>
                <span style="font-weight: 500; font-size: 1.35rem; color: #000; margin-left: 0.5rem;">{{ item.title
                }}</span>
              </div>
              <div v-else style="display: flex; justify-content: center; align-items: center;">
                <span style="font-weight: 500; font-size: 1.35rem; color: #000; margin-left: 0.5rem;">{{
                  item.description }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 旅游卡介绍 -->
    <div v-if="card_introduction1 && card_introduction1.img"
      :style="{ backgroundImage: 'url(' + card_introduction1.img + ')', width: '100%', height: '150rem', backgroundSize: 'cover', backgroundPosition: 'center' }"
      style="position: relative;">
    </div>

    <!-- 旅游小程序 -->
    <div v-if="card_introduction2 && card_introduction2.img"
      :style="{ backgroundImage: 'url(' + card_introduction2.img + ')', width: '100%', height: '240rem', backgroundSize: 'cover', backgroundPosition: 'center' }"
      style="position: relative;">
      <div class="phone1-1" @click="callPhone(1)"></div>
      <div class="phone1-2" @click="callPhone(2)"></div>
    </div>

    <!-- 手机端网站 -->
    <div v-if="mobileWebImg"
      :style="{ backgroundImage: 'url(' + mobileWebImg + ')', width: '100%', height: '150rem', backgroundSize: 'cover', backgroundPosition: 'center' }"
      style="position: relative;">
    </div>

    <!-- 文章 -->
    <div v-if="articles.length > 0"
      style="width: 100%; padding-bottom: 2rem; display: flex; justify-content: center; align-items: center;">
      <div class="container" style="width: 89%;">
        <div class="travel-articles">
          <div class="title" style="display: flex; flex-direction: column; align-items: self-start;">
            <span style="font-size: 5rem; font-weight: 700; color: #000;">折扣卡系统文章</span>
            <div style="width: 22%; height: 0.375rem; background-color: #0078ff; border: none;"></div>
            <div style="width: 100%; height: 0.0625rem; background-color: #ccc; border: none;"></div>
          </div>
          <div v-for="(article, index) in articles" :key="index" class="article-item" @click="openArticle(article)"
            style="margin-top: 2rem;">
            <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
              <img :src="article.picUrl" alt="Article Image" class="article-image" />
              <div class="article-content">
                <h3>{{ article.title }}</h3>
                <p class="article-meta">
                  <span class="article-meta-item">{{ article.browseCount }}阅读</span>
                  <span class="article-meta-item">{{ article.author }}</span>
                  <span class="article-meta-item">{{ article.createTime }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="article-div">
            <span style="color: transparent;">占位</span>
            <div style="font-size: 3rem; color: #0078FF;" @click="goToArticle()">更多 ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部分类 -->
    <div v-if="filteredData3.length > 0" class="footer" :style="{ backgroundImage: currentBackgroundImage }">
      <div class="menu-container" @click="selectCategory">
        <div v-for="(category, index) in filteredData3" :key="index"
          :class="['menu-item', { selected: selectedCategory === category.name }]" :data-category="category.name">
          {{ category.name }}
        </div>
      </div>
    </div>

    <!-- 底部-单图 -->
    <div v-if="footer_introduction_one && footer_introduction_one.img"
      :style="{ backgroundImage: 'url(' + footer_introduction_one.img + ')', width: '100%', height: '130.635rem', backgroundSize: 'cover', backgroundPosition: 'center' }"
      style="position: relative;">
      <div class="phone1-1" style="top: 1%;" @click="callPhone(1)"></div>
      <div class="phone1-2" style="top: 12%;" @click="callPhone(2)"></div>
    </div>

    <!-- 备案号 -->
    <div style="width: 100%;height: 10rem; display: flex;justify-content: center;align-items: center;">
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: #ccc;">
        浙ICP备16018953号-1
      </a>
    </div>

    <!-- 固定悬浮窗 -->
    <div v-if="fixed_position && fixed_position.img" style="position: fixed; top: 40.725rem; right: 3.125rem;">
      <img :src="fixed_position.img" alt="wechat" style="width: 7rem; height: 12rem;" />
    </div>

    <!-- 小程序二维码弹窗 -->
    <el-dialog title="" :visible.sync="dialogVisible" width="30%">
      <div v-if="card_introduction2 && card_introduction2.img1"
        style="display: flex; justify-content: center; align-items: center;">
        <img :src="card_introduction2.img1" style="width: 25rem; height: 25rem;" alt="wechat" />
      </div>
      <span v-else style="display: flex; justify-content: center; align-items: center;">暂无数据</span>
    </el-dialog>

    <!-- 微信号弹窗 -->
    <el-dialog title="" :visible.sync="copyShow" width="80%" top="40vh" custom-class="custom-dialog">
      <div style="width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <img src="https://lcd-img-hangzhou.oss-cn-hangzhou.aliyuncs.com/TravelWebsite/copy.png" alt="wechat"
          style="width: 24.625rem; height: 24.875rem;" />
        <span style="font-family: Source Han Sans CN; font-weight: 400; font-size: 4.875rem; margin-top: 3.5rem;">微信号：{{
          wechat }}</span>
        <span
          style="font-family: Source Han Sans CN; font-weight: 400; font-size: 4.875rem; margin-top: 3.5rem;">打开微信添加好友，详细了解产品</span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTemplate, getArticle } from '@/api/index';
// 引入 Swiper 样式和组件（Vue 2）
import 'swiper/css/swiper.css'; // 推荐使用 bundle 版本
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

export default {
  components: {
    swiper: Swiper,
    swiperSlide: SwiperSlide
  },
  data() {
    return {
      hoverIndex: null,
      articles: [],
      selectedCategory: null,
      categories: [],
      dialogVisible: false,
      headerData: {},
      Company_Profile: {
        bgImgs: [],
        title1: '',
        title2: '',
        data1: [],
        data2: []
      },
      Project_Introduction: null,
      card_introduction1: null,
      card_introduction2: null,
      footer_introduction: null,
      footer_introduction_one: null,
      fixed_position: null,
      copyShow: false,
      wechat: '',
      mobileWebImg: 'https://lcd-img-hangzhou.oss-cn-hangzhou.aliyuncs.com/travelWeb.png',

      // Swiper 配置
      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: true
      }
    };
  },
  computed: {
    ProjectData() {
      const data = this.Project_Introduction;
      if (Array.isArray(data)) {
        return data.filter(item => item.title && item.description);
      }
      if (typeof data === 'object' && data !== null) {
        return [data].filter(item => item.title && item.description);
      }
      return [];
    },
    filteredData1() {
      return (this.Company_Profile.data1 || []).filter(
        item => item.img && item.content
      );
    },
    filteredData2() {
      return (this.Company_Profile.data2 || []).filter(
        item => item.img && item.name
      );
    },
    currentBackgroundImage() {
      if (!this.selectedCategory) return '';
      const selectedCategory = this.categories.find(category => category.name === this.selectedCategory);
      return selectedCategory ? `url(${selectedCategory.img})` : '';
    },
    filteredData3() {
      return (this.categories || []).filter(item => item.name);
    }
  },
  mounted() {
    this.getTemplate();
    this.getArticle();

    // 可选：延迟启动自动播放（确保 swiper 已初始化）
    setTimeout(() => {
      this.startAutoPlay();
    }, 500);
  },
  methods: {
    getTemplate() {
      getTemplate().then(res => {
        let info = res.data.data;
        let webData = JSON.parse(info.property);

        const rawBg = webData.Company_Profile?.bgImg || webData.Company_Profile?.bgImgs;
        let bgImgs = [];
        if (Array.isArray(rawBg)) {
          bgImgs = rawBg;
        } else if (typeof rawBg === 'string' && rawBg.trim()) {
          bgImgs = [rawBg];
        }

        this.headerData = webData.headerData || {};
        this.Company_Profile = {
          ...this.Company_Profile,
          ...(webData.Company_Profile || {}),
          bgImgs
        };
        this.Project_Introduction = webData.project_introduction || null;
        this.card_introduction1 = webData.card_introduction1 || null;
        this.card_introduction2 = webData.card_introduction2 || null;
        this.footer_introduction = webData.footer_introduction || null;
        this.footer_introduction_one = webData.footer_introduction_one || null;
        this.fixed_position = webData.fixed_qrcode || null;
        this.categories = (this.footer_introduction?.data) || [];
        this.wechat = this.headerData.content || '';

        if (this.categories.length > 0 && !this.selectedCategory) {
          this.selectedCategory = this.categories[0].name;
        }
      });
    },

    pauseAutoPlay() {
      const swiper = this.$refs.companySwiper?.swiper;
      if (swiper && swiper.autoplay) {
        swiper.autoplay.stop();
      }
    },
    startAutoPlay() {
      const swiper = this.$refs.companySwiper?.swiper;
      if (swiper && swiper.autoplay) {
        swiper.autoplay.start();
      }
    },

    goTouristCardProject(item) {
      const routes = { introduce: 'introduce', cooperate: 'cooperate', income: 'income', feedback: 'feedback' };
      const name = routes[item.url];
      if (name) {
        this.$router.push({ name, params: { img: item.img1 } });
      }
    },
    getArticle() {
      getArticle(101).then(res => {
        this.articles = res.data.rows || [];
      });
    },
    goToApp() {
      this.dialogVisible = true;
    },
    selectCategory(event) {
      const categoryName = event.target.getAttribute('data-category');
      if (categoryName) {
        this.selectedCategory = categoryName;
      }
    },
    openArticle(item) {
      if (item.type == 2) {
        window.open(item.content, '_blank');
      } else {
        this.$router.push({ name: 'article', params: { id: item.id } });
      }
    },
    goToPage(url) {
      console.log(url);
    },
    goToArticle() {
      this.$router.push({ name: 'morearticle' });
    },
    openPopup() {
      const content = this.wechat;
      const a = document.createElement('a');
      a.href = `tel:${content}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    callPhone(id) {
      if (id == 1) {
        const content = '15381161170';
        const a = document.createElement('a');
        a.href = `tel:${content}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
      if (id == 2) {
        const content = '18657114202';
        const a = document.createElement('a');
        a.href = `tel:${content}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
    copyToClipboardFallback(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        this.$message?.success('微信号已复制');
      } catch (err) {
        this.$message?.error('请手动复制微信号');
      }
      document.body.removeChild(textarea);
    }
  }
};
</script>

<style scoped>
/* ========== Swiper 轮播样式 ========== */
.company-carousel {
  position: relative;
  width: 100%;
  height: 100rem;
  /* 使用视口高度，更合理 */
  overflow: hidden;
}

.swiper-slide-custom {
  width: 100%;
  height: 100rem;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: white;
  padding: 0 5%;
  box-sizing: border-box;
}

/* 分页器样式 */
.swiper-pagination {
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.5rem;
}

.swiper-pagination-bullet {
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  opacity: 1;
  transition: background 0.3s;
}

.swiper-pagination-bullet-active {
  background: white !important;
}

.phone1-1 {
  width: 35rem;
  height: 10rem;
  position: absolute;
  top: 88%;
  left: 68%;
}

.phone1-2 {
  width: 35rem;
  height: 10rem;
  position: absolute;
  top: 93%;
  left: 68%;
}

/* ========== 其他原有样式保持不变 ========== */
body {
  transform: scale(0.5);
  transform-origin: top left;
  overflow: hidden;
}

.container {
  width: 80%;
  margin: 0 auto;
}

.logoTitle {
  color: #000;
  font-size: 5rem;
  margin-left: 20px;
}

.option {
  transition: background-color 0.3s ease;
  border: 0.09375rem solid #0078FF;
}

.option-hover {
  background-color: #ffeba2;
  border: 0.09375rem solid #ffeba2;
}

.travel-articles {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1);
  padding: 1.25rem;
  border-radius: 1.875rem;
}

.article-item {
  display: flex;
  align-items: center;
  padding-bottom: 1rem;
}

.article-image {
  width: 30rem;
  height: 20rem;
  object-fit: cover;
  margin-right: 0.625rem;
}

.article-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 18rem;
  margin-left: 2rem;
}

.article-content h3 {
  font-size: 4rem;
  margin: 0 0 0.3125rem;
}

.article-meta {
  display: flex;
  justify-content: space-between;
  align-self: self-start;
  width: fit-content;
  margin: 0;
}

.article-meta-item {
  margin-right: 0.625rem;
  font-size: 3rem;
  color: #999;
  padding-right: 1rem;
}

.article-div {
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
}

.footer {
  width: 100%;
  height: 45.5rem;
  background-size: cover;
  background-position: center;
  position: relative;
}

.menu-container {
  position: absolute;
  top: 15.5rem;
  right: 16.0625rem;
  width: 12.25rem;
  height: 10.75rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #fff;
}

.menu-item {
  width: 100%;
  height: 3rem;
  line-height: 3rem;
  padding: 0 1.375rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.menu-item.selected {
  background-color: #3a3f48;
}

.custom-dialog {
  border-radius: 20px !important;
}

@media (max-width: 768px) {
  .article-meta-item {
    font-size: 2rem;
  }
}
</style>